const actualHoistNonReactStatics = require('hoist-non-react-statics');

// Export the function itself as the module's main export
module.exports = { default: actualHoistNonReactStatics };

// Also, explicitly provide it as a 'default' property
// This helps ESM importers that might be looking for a .default
module.exports.default = actualHoistNonReactStatics;